import { useEffect, useMemo, useRef, useState } from "react";
import moment from "jalali-moment";

import { Box, Button, Card, Checkbox, Chip, Collapse, Fade, Grid, IconButton, Stack, Typography } from "@mui/material";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";

import { DESTINATION, LAYOUT_MARGIN, SOURCE } from "Configs/home";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useWindowSize from "Hooks/useWindowSize";

import { deselectPath } from "Redux/servicesSlice";
import { setMapData } from "Redux/mapSlice";
import destinationSvg from "Assets/Images/Survey/destination-icon.svg";
import usePaths from "Hooks/usePaths";
import useEditPath from "Hooks/useEditPath";
import { statusConverter } from "Helper/sidebar";
import { selectInventory } from "Redux/inventorySlice";
import { changeShowSupportLeftSide } from "Redux/sideSlice";
import { changeSupportRightSideMode } from "Redux/supportSideSlice";
import { invData } from "./inventoryData";

// Doesn't look good but it works :(
const SIZES: { [key: string]: number } = {
  operationBoxHeight: 56,
  marginTop: 8,
  toolsBoxHeight: 56,
  marginBottom: 8,
  topContent: 70,
  bottomContentMargin: 16,
};

export default function Inventory() {
  const dispatch = useAppDispatch();

  const { visible: visibleInventory } = useAppSelector((state) => state.supportInventory);
  const data = usePaths();

  const { height } = useWindowSize();

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const toggleCollapse = () => setIsOpen((prev) => !prev);

  const sideRef = useRef<HTMLDivElement>(null);

  const boxHeight = useMemo(() => {
    let result = 0;
    Object.keys(SIZES).forEach((key) => {
      result += SIZES[key];
    });
    return `${height - (result + LAYOUT_MARGIN * 2)}px`;
  }, [height]);

  const handleClick = (e: any, inv: any) => {
    dispatch(changeSupportRightSideMode(2));
    dispatch(selectInventory(inv));
  };

  const renderInventory = () => {
    return (
      <>
        <Stack direction="row" sx={{ mb: "20px", alignItems: "center" }}>
          <Typography sx={{ width: "90%" }}>انتخاب همه :</Typography>
        </Stack>
        {invData?.map((inv, index) => {
          const startDate = moment(inv.startDate * 1000 + Math.floor(index / 18) * 86400000)
            .locale("fa")
            .format("jYYYY/jMM/jDD");
          const { status, color } = statusConverter("enable");
          const hour = Math.floor(inv.startTime / 3600);
          const minutes = (inv.startTime % 3600) / 60;
          const endTime = inv.startTime + inv.estimateTime;
          const endHour = Math.floor(endTime / 3600);
          const endMinutes = (endTime % 3600) / 60;

          return (
            <Stack direction="row">
              <Button
                sx={{
                  border: "1px solid #aaa",
                  p: 1,
                  borderRadius: 1,
                  width: "98%",
                  marginBottom: "15px",
                  justifyContent: "flex-start",
                }}
                onClick={(e) => handleClick(e, inv)}
              >
                <Stack sx={{ width: "100%" }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item xs={5} textAlign="left" sx={{ mb: "10px" }} className="fa-number">
                      <Typography color="common.black">{startDate}</Typography>
                    </Grid>
                    <Grid item xs={4} textAlign="left" sx={{ mb: "10px" }}>
                      <Typography color="common.black">{inv.code}</Typography>
                    </Grid>
                    <Grid item xs={3} textAlign="right" sx={{ mb: "10px" }}>
                      <Typography color="common.black">
                        {" "}
                        <Chip label={status} style={{ color }} />
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item xs={9} textAlign="left" sx={{ mb: "10px" }} container>
                      <img src={SOURCE} alt="logo" style={{ width: "15px" }} />
                      <Typography color="common.black" sx={{ ml: "10px" }}>
                        از : {inv.path.stations[0].title}
                      </Typography>
                    </Grid>
                    <Grid item xs={2.5} textAlign="right" sx={{ mr: "10px" }} className="fa-number">
                      {minutes < 10 ? `0${minutes}` : minutes} : {hour}
                    </Grid>
                  </Grid>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item xs={9} textAlign="left" sx={{ mb: "10px" }} container>
                      <img src={DESTINATION} alt="logo" style={{ width: "15px" }} />
                      <Box color="common.black" sx={{ ml: "10px", textOverflow: "ellipsis", overflow: "hidden" }}>
                        به : {inv.path.stations[1].title}
                      </Box>
                    </Grid>
                    <Grid item xs={2.5} textAlign="right" sx={{ mr: "10px" }} className="fa-number">
                      {endMinutes < 10 ? `0${endMinutes}` : endMinutes} : {endHour}
                    </Grid>
                  </Grid>
                </Stack>
              </Button>
            </Stack>
          );
        })}
      </>
    );
  };

  return (
    <Fade in={visibleInventory} mountOnEnter unmountOnExit>
      <Card sx={{ mt: 1, p: 2, width: "100%", boxShadow: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontWeight="800">لیست برنامه حرکت</Typography>

          <Button
            startIcon={<KeyboardDoubleArrowDownIcon sx={{ transform: isOpen ? "rotate(180deg)" : "", transition: "all 0.3s" }} />}
            sx={{ minWidth: "100px" }}
            onClick={toggleCollapse}
          >
            {isOpen ? "بستن" : "بازکردن"}
          </Button>
        </Stack>

        <Collapse in={isOpen}>
          <Box sx={{ height: boxHeight, py: 2, overflowY: "scroll" }} ref={sideRef}>
            {invData.length === 0 ? <Typography align="center">مسیری برای نمایش وجود ندارد</Typography> : renderInventory()}
          </Box>
        </Collapse>
      </Card>
    </Fade>
  );
}
